<template>
    <div class="card-styles--setting card-styles--card">
        <h2>3. Ajustes</h2>

        <!-- <select v-model="colorTeam" @change="setCardColors">
            <option v-for="option in colorTeams" :value="option.value">
            {{ option.text }}
            </option>
        </select> -->

        <select v-model="colorTeam" @change="setCardColors">
            <option v-for="option in colorTeams" :value="option.value" :key="option.value">
            {{ option.text }}
            </option>
        </select>

        <div class="card-styles--card-options" v-show="colorTeam == 'customColors'">
            <div>
                <label for="">Elemento 1</label>
                <!-- <input type="color" v-model="cardColors.trapColors"> -->
                <LvColorpicker v-model="cardColors.trapColors1" :value="cardColors.trapColors1" withoutInput hidePalette @input="setTrapColors1(cardColors.trapColors1)" />
            </div>

            <div>
                <label for="">Elemento 2</label>
                <!-- <input type="color" v-model="cardColors.trapColors"> -->
                <LvColorpicker v-model="cardColors.trapColors2" :value="cardColors.trapColors2" withoutInput hidePalette @input="setTrapColors2(cardColors.trapColors2)" />
            </div>

            <div>
                <label for="">línea</label>
                <!-- <input type="color" v-model="cardColors.trapBorder"> -->
                <LvColorpicker v-model="cardColors.trapBorder" :value="cardColors.trapBorder" withoutInput hidePalette @input="setTrapBorder(cardColors.trapBorder)" />
            </div>

            <div>
                <label for="">fondo</label>
                <!-- <input type="color" v-model="cardColors.backgroundMask"> -->
                <LvColorpicker v-model="cardColors.backgroundMask" :value="cardColors.backgroundMask" withoutInput hidePalette @input="setBackgroundMask(cardColors.backgroundMask)" />
            </div>

            <div>
                <label>estampado</label>

                <div class="round-color-picker-wrap">
                    <!-- <input type="color" v-model="cardColors.backgroundLinesColor" class="round-color-picker"> -->
                    <LvColorpicker v-model="cardColors.backgroundLinesColor" :value="cardColors.backgroundLinesColor" withoutInput hidePalette @input="setBackgroundLinesColor(cardColors.backgroundLinesColor)" />
                </div>
            </div>

            <!-- <div class="noborder-bottom">
                <label>Background Lines Opacity:</label>
                <input type="number" max="1" step="0.1" min="0" v-model="cardColors.backgroundLinesColorOpacity">
            </div> -->
            <div class="noborder-bottom"></div>
            <div class="noborder-bottom"></div>
        </div>

        <div class="card-styles--savetemplates" v-show="colorTeam == 'customColors' && isLoggedIn">
            <p>Guardar estilo personalizado</p>
            <label>Nombre de estilo:</label>
            <div class="create-template--inputs">
                <input v-model="templateName" type="text" ref="templateName" @input="showSaveTemplate" :class="{highlightField:highlightField}" @focus="highlightField = false">
                <button v-if="showSaveTemplateButton" class="button2" @click="createCardTemplate">Guardar</button>
                <button v-else class="button3" v-tooltip.top.focus="'Añadir nombre.'" @click="highlightInputField">Guardar</button>
            </div>
            <div v-if="templateNameUnvalidCharacters" class="templateNameUnvalidCharacters">
                Solo se permiten letras y/o números.
            </div>
        </div>
        <div class="updateThemeMessage" v-if="showTemplateUpdateMessage">
            Se han guardado los cambios en plantilla: {{ templateName }}.
        </div>


    </div>
</template>

<script>
import LvColorpicker from 'lightvue/color-picker';
import LvButton from 'lightvue/button';
import Tooltip from 'lightvue/tooltip';
import axios from 'axios';
export default {
    props: ['cardColors'],
    data() {
        return {
            templateNameUnvalidCharacters: false,
            highlightField: false,
            showTemplateUpdateMessage: false,
            templateName: '',
            showSaveTemplateButton: false,
            colorTeam: 'customColors',
            selectedColors: {},
            customColors: {
                trapColors1 : '#FFD500',
                trapColors2: '#FCB806',
                trapBorder: '#8F1B2E',
                backgroundMask: '#8F1B2E',
                backgroundLinesColor: '#C2345A'
            },
            realmadrid: {
                trapColors1 : '#FFD500',
                trapColors2: '#FCB806',
                trapBorder: '#A16E99',
                backgroundMask: '#A16E99',
                backgroundLinesColor: '#B9A6C6'
            },
            barca: {
                trapColors1 : '#FFD500',
                trapColors2: '#FCB806',
                trapBorder: '#9D2F39',
                backgroundMask: '#9D2F39',
                backgroundLinesColor: '#D33755'
            },
            colorTeams: [
                {
                    text: 'Personalizado',
                    value: 'customColors'
                },
                {
                    text: 'Real Madrid',
                    value: 'realmadrid'
                    
                },
                {
                    text: 'Barcelona',
                    value: 'barca'
                },
                {
                    text: 'Guantes de Oro',
                    value: 'keeper'
                },
                {
                    text: 'Balón de Oro',
                    value: 'balonoro'
                }
            ]
        }
    },

    directives: {
        tooltip: Tooltip,
    },

    methods: {

        highlightInputField() {
            this.highlightField = true;
            setTimeout(()=>{
                this.highlightField = false;
            },3000)
        },

        showSaveTemplate() {
            let templateName = this.templateName;
            
            // Check if templateName is not undefined, not an empty string, and not only whitespace
            if (templateName !== undefined && templateName !== '' && templateName.trim() !== '') {
                // Check if templateName contains only numbers and text characters
                const isValidTemplateName = /^[A-Za-z0-9\s]+$/.test(templateName);

                if (isValidTemplateName) {
                   
                    this.showSaveTemplateButton = true;
                    this.templateNameUnvalidCharacters = false;
                } else {
                    console.log('Template name contains invalid characters.');
                    this.showSaveTemplateButton = false;
                    this.templateNameUnvalidCharacters = true;
                }
            } else {
                console.log('Template name is undefined, empty, or only whitespace.');
                this.showSaveTemplateButton = false;
            }
        },


        createCardTemplate() {

            const existingTemplateIndex = this.$store.state.user.savedTemplates.findIndex(
                (template) => template.text === this.templateName || template.value === this.templateName
            );

            let templateNameUpdated = this.templateName;

            if (existingTemplateIndex !== -1) {
                // Update existing template
                this.showTemplateUpdateMessage = true;
                
                this.$store.state.user.savedTemplates[existingTemplateIndex] = {
                    text: this.templateName,
                    value: this.templateName,
                    trapColors1: this.customColors.trapColors1,
                    trapColors2: this.customColors.trapColors2,
                    trapBorder: this.customColors.trapBorder,
                    backgroundMask: this.customColors.backgroundMask,
                    backgroundLinesColor: this.customColors.backgroundLinesColor,
                };
                setTimeout(()=>{
                    this.showTemplateUpdateMessage = false;
                    this.templateName = '';
                }, 3000);

            } else {
                // Add new template
                if(
                    templateNameUpdated == 'customColors' || 
                    templateNameUpdated == 'realmadrid' || 
                    templateNameUpdated == 'barca' || 
                    templateNameUpdated == 'keeper' || 
                    templateNameUpdated == 'balonoro' 
                    ){
                        templateNameUpdated = templateNameUpdated+'_new'
                    }
                this.$store.state.user.savedTemplates.push({
                    text: templateNameUpdated,
                    value: templateNameUpdated,
                    trapColors1: this.customColors.trapColors1,
                    trapColors2: this.customColors.trapColors2,
                    trapBorder: this.customColors.trapBorder,
                    backgroundMask: this.customColors.backgroundMask,
                    backgroundLinesColor: this.customColors.backgroundLinesColor,
                });

                setTimeout(()=>{this.templateName = '';},1000)
                
            }

            this.colorTeam = templateNameUpdated;
            
            this.showSaveTemplateButton = false;
            

            

            this.saveTemplateToDB();

            // this.$emit('checkForSavedTemplates')

            this.checkForSavedTemplates();

        },

        // async getTemplatesFromDb() {
            
        //     console.log(`jwt getting templates: ${this.$store.state.user.tokenId}`);
        //     const response = await axios.get(
        //         'https://cartafutbol.com/api/v1/Template/getTemplates.php',
        //         {headers: {
        //             'Authorization': `Bearer ${this.$store.state.user.tokenId}`
        //         }},
        //     );

        //     console.log('from get templates',response.data.templates);
        // },
        getTemplatesFromDbCardSettingsStyles() {
            this.$emit('getTemplatesFromDbCardSettingsStyles');
        },

        saveTemplateToDB() {

            try {
                
                let temps = this.$store.state.user.savedTemplates;
                console.log('from saveTemplateToDB:',temps)

                const data = {
                templates: temps
                };

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://www.cartafutbol.com/api/v1/Template/saveTemplate.php',
                    headers: { 
                        'Content-Type': 'application/json', 
                        'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                    },
                    data : data
                };

                axios.request(config).then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });

            } catch (error) {
                // Handle errors here
                console.error('Error saving template:', error.message);
            }
        },


        setTrapColors1(color) {
            // this.customColors.trapColors1 = color;
            setTimeout(()=>{
                this.customColors.trapColors1 = this.cardColors.trapColors1;
            },100);
        },
        setTrapColors2(color) {
            setTimeout(()=>{
                this.customColors.trapColors2 = this.cardColors.trapColors2;
            },100);
        },
        setBackgroundMask(color) {
            setTimeout(()=>{
                this.customColors.backgroundMask = this.cardColors.backgroundMask;
            },100);

        },
        setTrapBorder(color) {
            setTimeout(()=>{
                this.customColors.trapBorder = this.cardColors.trapBorder;
            },100);

        },
        setBackgroundLinesColor(color) {
            setTimeout(()=>{
                this.customColors.backgroundLinesColor = this.cardColors.backgroundLinesColor;
            },100);

        },
        setCardColors() {
            this.$root.cardColors.isKeeper = false
            this.$root.cardColors.isBalonOro = false
            if(this.colorTeam !== 'keeper' && this.colorTeam !== 'balonoro') {
                this.$root.cardColors.backgroundMask = this[this.colorTeam].backgroundMask
                this.$root.cardColors.trapColors1 = this[this.colorTeam].trapColors1
                this.$root.cardColors.trapColors2 = this[this.colorTeam].trapColors2
                this.$root.cardColors.trapBorder = this[this.colorTeam].trapBorder
                this.$root.cardColors.backgroundLinesColor = this[this.colorTeam].backgroundLinesColor
            } else if(this.colorTeam === 'keeper') {
                this.$root.cardColors.isKeeper = true
            } else {
                this.$root.cardColors.isBalonOro = true
            }

        },

        checkForSavedTemplates() {
            this.$store.state.user.savedTemplates.forEach((template) => {
                // Check if this[template.text] already exists
                if (Object.prototype.hasOwnProperty.call(this, template.text)) {
                // If it exists, update the existing property
                this[template.text] = {
                    trapColors1: template.trapColors1,
                    trapColors2: template.trapColors2,
                    trapBorder: template.trapBorder,
                    backgroundMask: template.backgroundMask,
                    backgroundLinesColor: template.backgroundLinesColor,
                };
                } else {
                // If it doesn't exist, add the property
                this[template.text] = {
                    trapColors1: template.trapColors1,
                    trapColors2: template.trapColors2,
                    trapBorder: template.trapBorder,
                    backgroundMask: template.backgroundMask,
                    backgroundLinesColor: template.backgroundLinesColor,
                };

                // Add to colorTeams array
                this.colorTeams.push({
                    text: template.text,
                    value: template.value,
                });
                }
            });
        }


        
        

    },

    components: {
        LvColorpicker,
        LvButton
    },

    computed: {
        
        // combinedOptions() {
        //     const colorTeams = this.colorTeams;
        //     const savedTemplates = this.$store.state.user.savedTemplates || [];

        //     // Check if savedTemplates array has items
        //     if (savedTemplates.length > 0) {
        //         return [...colorTeams, ...savedTemplates];
        //     } else {
        //         return colorTeams;
        //     }
        // },
        isLoggedIn() {
            return this.$store.state.loggedIn
        }
    },
    mounted() {
        // this.getTemplatesFromDb('from mounted');
        // this.checkForSavedTemplates();
    }
}
</script>

<style lang="less">
.card-creator--settings {
    .lv-colorpicker-wrapper {
        border: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius_global);
        padding: 0;
        background: none;
        padding: 0.23rem;
        background: var(--input_bg);
        border: var(--input_borderwidth) solid var(--input_bordercolor);

        .lv-colorpicker__colorblock-wrap {
            width: 35px;
            height: 35px;
            top: auto;
            right: auto;
            border-radius: var(--radius_global)!important;
            transform: none;
        }
    }
}

.vc-chrome-alpha-wrap {
    display: none;
}

.vc-chrome-hue-wrap {
    margin-top: 8px;
    margin-bottom: 0;
}

.vc-chrome-toggle-btn {
    display: none;
}

.card-styles--card-options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    & > div {
        width: calc(33% - 1rem);
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        input[type=number]{
            width: 75px;
            height: 40px;
        }
    }
}

.create-template--inputs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.updateThemeMessage {
    padding: 1rem;
    background: var(--grey_light);
    border-radius: var(--radius_global);
    margin: 1rem 0;
    max-width: 350px;
    font-weight: 600;
    font-size: 0.85rem;
}

.card-styles--savetemplates {
    padding: 1rem;
    border-radius: var(--radius_global);
    margin-top: 2rem;
    background: var(--infobox-bg);
}

.highlightField {
    animation: flashBorder 0.5s ease alternate infinite;
}

@keyframes flashBorder {
    from {
        border-color: var(--input_bordercolor);
        transform: scale(0.95);
    } to {
        border-color: var(--blue_main);
        transform: scale(1.05);
    }
}

.templateNameUnvalidCharacters {
    font-size: 0.85rem;
    font-weight: 600;
    color: red;
    margin-top: 0.5rem;
}

</style>